/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import BackAnchor from '../../../../shared/components/BackAnchor'

const FinesQuestionView = ({ t, i18n }) => {
  const getPayAFineUrl = () => {
    const origin = window.location.origin
    if (origin.includes('dev-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://dev-finepayments.ds4u.novascotia.dev/fr/amendes-info'
    } else if (origin.includes('test-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://test-finepayments.ds4u.novascotia.dev/fr/amendes-info'
    } else if (origin.includes('uat-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://uat-finepayments.ds4u.novascotia.dev/fr/amendes-info'
    } else {
      return i18n.language === 'en' ? 'https://finepayment.novascotia.ca/en/fine-info' : 'https://finepayment.novascotia.ca/fr/amendes-info'
    }
  }

  const getPayDefaultedFinesUrl = () => {
    const origin = window.location.origin
    if (origin.includes('dev-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-rmvadminfee.ds4u.novascotia.dev/en/fines-question'
        : 'https://dev-rmvadminfee.ds4u.novascotia.dev/fr/amendes-verification'
    } else if (origin.includes('test-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-rmvadminfee.ds4u.novascotia.dev/en/fines-question'
        : 'https://test-rmvadminfee.ds4u.novascotia.dev/fr/amendes-verification'
    } else if (origin.includes('uat-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-rmvadminfee.ds4u.novascotia.dev/en/fines-question'
        : 'https://uat-rmvadminfee.ds4u.novascotia.dev/fr/amendes-verification'
    } else {
      return i18n.language === 'en'
        ? 'https://rmvadminfeepayment.novascotia.ca/en/fines-question'
        : 'https://rmvadminfeepayment.novascotia.ca/fr/amendes-verification'
    }
  }

  const payAFineUrl = getPayAFineUrl()
  const payDefaultedFinesUrl = getPayDefaultedFinesUrl()

  const getPhoneNumber = (text) => {
    return `tel:${t(text)}`
  }

  const handleLink = (url) => (e) => {
    e.preventDefault()
    window.open(url, '_blank')
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <BackAnchor />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{t('title')}</h1>
          <h3>{t('fines_yes.if_you_have_any')}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-7">
          <ul>
            <li>{t('fines_yes.fines_that_were_not')}</li>
            <li>
              <a onClick={handleLink(payAFineUrl)} href={`/${i18n.language}${t('routes.fines_question')}`}>
                {t('fines_yes.pay_your_fines')}
              </a>
              {t('fines_yes.before_you_renew')}
            </li>
            <li>
              <a onClick={handleLink(payDefaultedFinesUrl)} href={`/${i18n.language}${t('routes.fines_question')}`}>
                {t('fines_yes.pay_a_fee')}
              </a>
              {i18n.language === 'fr' && '.'}
            </li>
            <li>
              {t('fines_yes.if_you_need_help')}
              <a href={getPhoneNumber('fines_yes.number')}>{t('fines_yes.number')}</a>
            </li>
            <li>{t('fines_yes.if_you_are_unsure_about')}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(FinesQuestionView)
